
// Constants for categories
export const CATEGORIES_TABLE = 'Categorias';
